import React, { useEffect, useContext, useState } from "react";
import { useParams } from "react-router-dom";
import {
  PostCallWithErrorResponse,
  simpleGetCallWithToken,
  simplePatchCall,
  simplePostCall,
  simplePostCallIVT,
  simplePostTokenCall,
} from "../../api/ApiServices";
import ApiConfig, { BASE_URL_CHATADMIN } from "../../api/ApiConfig";
import Loader from "./loader";
import NoDataFound from "./NodataFound";
import { AppContext } from "../../context/AppContext";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BookDown, Copy, Eye } from "lucide-react";
import { notifyError, notifySuccess } from "../../toaster/notify";
import ReactMarkdown from "react-markdown";
import { ToastMsg } from "../TostMsg";

const SubTestCaseStatistics = () => {
  const [subTestStat, setsubTestStat] = useState([]);

  const { moduleName } = useParams();

  const { sidebar, selectedDomainId, domainName } = useContext(AppContext);

  const [isLoading, setIsLoading] = useState(false);
  const [SubModulName, setSubModulName] = useState("");

  const [aiimage, setAiimage] = useState(false);

  const [isIlstrViewimage, setIsIlstrViewImage] = useState("");
  const [isIlstrView, setIsIlstrView] = useState("");
  console.log("isIlstrViewimage", isIlstrViewimage);

  const [reportData, setReportData] = useState(null);
  const [aiLoading, setAiLoading] = useState(false);

  const getSubModuleSatic = () => {
    setIsLoading(true);

    simpleGetCallWithToken(
      ApiConfig?.GET_SUB_Module_STATIC +
      `?domain_id=${selectedDomainId}&module_name=${moduleName}`
    ).then((res) => {
      if (res?.success) {
        setsubTestStat(res?.data);
      } else {
        setsubTestStat([]);
      }
      setIsLoading(false);
    });
  };

  useEffect(() => { }, [SubModulName]);

  useEffect(() => {
    getSubModuleSatic();
  }, [selectedDomainId]);

  const handleGenerateReport = (Modulname) => {
    setIsLoading(true);

    const payload = {
      domain_id: selectedDomainId,
      module: moduleName,
      sub_module: Modulname?.replace(/[\s_]+/g, ""),
    };

    simplePostCallIVT(
      "https://cloudxperte.crm-api.wifiattendance.com:3016/api/generate-testcase-flow",
      JSON.stringify(payload)
    )
      .then((res) => {
        if (res?.success) {
          notifySuccess("AI Report generated successfully");
        } else {
          notifyError(res?.message || "Failed to generate AI report");
        }
      })
      .catch((err) => {
        console.error("Error generating report:", err);
        notifyError("Something went wrong while generating report");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleViewReport = (moudelname) => {
    setIsLoading(true);
    setIsIlstrView(true);

    // ✅ Build full API URL properly
    const url = `https://cloudxperte.crm-api.wifiattendance.com:3016/api/get-testcase-flow?domain_id=${selectedDomainId}&module=${moduleName}&sub_module=${moudelname?.replace(
      /[\s_]+/g,
      ""
    )}`;

    simpleGetCallWithToken(url)
      .then((res) => {
        if (res?.success) {
          setReportData(res?.data);
        } else {
          setReportData(null);
          notifyError("No report found ");
        }
      })
      .catch((err) => {
        console.error("Error fetching report:", err);
        notifyError("Failed to load report ");
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const generateAiQuesAns = (subModule) => {

    PostCallWithErrorResponse(ApiConfig.GENERATE_AI_QUES_ANS, JSON.stringify({
      "domain_id": selectedDomainId,
      "module": moduleName,
      "sub_module": subModule
    })).then((res) => {

      if (res?.json?.success) {
        ToastMsg('success', 'AI Q&A generated successfully')
      } else {
        ToastMsg('error', res?.json?.message || 'Failed to generate AI Q&A')
      }

    })

  }

  return (
    <div className="main_container">
      <div
        className={sidebar ? "taskMain " : "cx-active taskMain"}
        id="cx-main"
      >
        <div>
          <div className="role-content">
            <div className="sub-header-role d-flex justify-content-between">
              <h6 className="mt-2">{moduleName} Statistics</h6>

              <h6 className="mt-2 mr-2">Domain Name : {domainName}</h6>
            </div>

            <div
              className="table-wrapper table-wrapper-2"
              style={{ height: "600px" }}
            >
              {isLoading ? (
                <Loader />
              ) : subTestStat.length > 0 ? (
                <table style={{ marginBottom: "20px" }}>
                  <thead className="">
                    <tr className="firstTabelRow">
                      <th>Sr. no</th>
                      <th>Sub-Module Name</th>
                      <th>Test Case Count</th>
                      <th>Image</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {subTestStat?.map((sub, index) => {
                    return (
                      <tr key={index} className="table-row-custom">
                        <td>{index + 1}</td>
                        <td>{sub?.sub_module_name}</td>
                        <td>{sub?.count}</td>
                        <td>
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 100, hide: 300 }}
                            overlay={
                              <Tooltip id={`tooltip-img-${sub.id}`}>
                                View Image
                              </Tooltip>
                            }
                          >
                            <img
                              src={BASE_URL_CHATADMIN + sub.illustration_pic}
                              alt="Sub Module Icon"
                              style={{
                                width: "30px",
                                height: "30px",
                                borderRadius: "6px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setIsIlstrViewImage(sub.illustration_pic);
                                setAiimage(true);
                              }}
                              onError={(e) =>
                                (e.target.src = "/icons/default.png")
                              }
                            />
                          </OverlayTrigger>
                        </td>
                        {/* --- Actions (View Report + Copy) --- */}
                        <td>
                          {/* View Report */}
                          <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip id="tooltip-view">View Report</Tooltip>
                            }
                          >
                            <Eye
                              className="cursor-pointer  h-5 text-blue-600"
                              onClick={() => {
                                setIsIlstrView(true);
                                handleViewReport(sub.sub_module_name);
                              }}
                            />
                          </OverlayTrigger>

                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 100, hide: 300 }}
                            overlay={
                              <Tooltip id="tooltip-ai">
                                Generate AI report
                              </Tooltip>
                            }
                          >
                            <BookDown
                              className="cursor-pointer h-6 text-green-600"
                              onClick={() => {
                                handleGenerateReport(sub.sub_module_name);
                                // getReportGrenter();
                              }}
                            // onClick={getReportGrenter}
                            />
                          </OverlayTrigger>
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 100, hide: 300 }}
                            overlay={
                              <Tooltip id="tooltip-ai">
                                Generate AI Q&A
                              </Tooltip>
                            }
                          >
                            <BookDown
                              className="cursor-pointer  h-6 text-green-600"
                              onClick={() => {
                                generateAiQuesAns(sub.sub_module_name);
                                // getReportGrenter();
                              }}

                            />
                          </OverlayTrigger>

                          {/* Copy Report Path */}
                        </td>
                      </tr>
                    );
                  })}
                </table>
              ) : (
                <NoDataFound />
              )}
            </div>
            <Modal
              className="delete-news-modal"
              show={isIlstrView}
              onHide={() => setIsIlstrView(false)}
              dialogClassName="modal-100w"
              centered
              style={{ maxWidth: "95%", width: "95%" }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Report Preview</Modal.Title>
              </Modal.Header>
              <div className="lineSeperate"></div>

              <div className="p-3">
                {isLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : reportData ? (
                  <>
                    {/* ✅ Copy Text Button */}
                    <div className="text-end mb-2">
                      <button
                        onClick={() => {
                          const textToCopy =
                            reportData?.flow_data?.replace(/\\n/g, "\n") || "";
                          navigator.clipboard.writeText(textToCopy);
                          notifySuccess("Report text copied to clipboard!");
                        }}
                        className="btn btn-sm btn-outline-primary"
                      >
                        Copy Text
                      </button>
                    </div>

                    {/* ✅ Markdown Preview */}
                    <div
                      style={{
                        background: "#f8f9fa",
                        padding: "20px",
                        borderRadius: "8px",
                        maxHeight: "500px",
                        overflowY: "auto",
                        fontSize: "15px",
                        lineHeight: "1.6",
                      }}
                    >
                      <ReactMarkdown>
                        {reportData?.flow_data?.replace(/\\n/g, "\n")}
                      </ReactMarkdown>
                    </div>

                    {/* ✅ Optional Copy Link Icon */}
                  </>
                ) : (
                  <p className="text-center text-muted">No report available.</p>
                )}
              </div>
            </Modal>

            <Modal
              className="delete-news-modal"
              show={aiimage}
              onHide={() => setAiimage(false)}
              centered
              style={{ maxWidth: "95%", width: "195%" }}
            >
              <Modal.Header closeButton>
                <Modal.Title>Image Preview</Modal.Title>
              </Modal.Header>
              <div className="lineSeperate"></div>

              <div className="p-3">
                {isLoading ? (
                  <div className="text-center py-4">Loading...</div>
                ) : reportData ? (
                  <>
                    {/* ✅ Copy Text Button */}

                    {/* ✅ Markdown Preview */}
                    <div
                      style={{
                        background: "#f8f9fa",
                        padding: "20px",
                        borderRadius: "8px",
                        maxHeight: "500px",
                        overflowY: "auto",
                        fontSize: "15px",
                        lineHeight: "1.6",
                      }}
                    >
                      <img
                        src={BASE_URL_CHATADMIN + isIlstrViewimage}
                        alt="Sub Module Icon"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "6px",
                          cursor: "pointer",
                        }}
                        onError={(e) => (e.target.src = "/icons/default.png")}
                      />
                    </div>

                    {/* ✅ Optional Copy Link Icon */}
                  </>
                ) : (
                  <p className="text-center text-muted">No report available.</p>
                )}
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubTestCaseStatistics;
